import type { CheckoutError } from "@store/types/OrderExceptions.types";
import type { ServerData, ServerDataFetchStatus } from "@store/types/ServerData.types";
import type { TradeInOrderAttributes } from "@store/types/TradeInOrderAttributes.types";

import type { Address, AddressStored, Contact, DateOfBirth, PgsPaymentMethod } from "@jti/fe-common";
import type { IGetOrderDeliveryLimits, OrderAttribute } from "@jti/magento";
import type { MagentoShippingMethod } from "@jti/magento-types";

export type Country = {
  countryName: string;
  countryCode: string;
};

export enum DeliveryOptionType {
  AtHome = "atHome",
  InStoreJti = "InStoreJti",
  InStoreReservation = "InStoreReservation",
  CustomDeliveryOption = "CustomDeliveryOption",
}

export type Checkout = {
  country: Country;
  addresses: ServerData<AddressStored[]>;
  shippingMethods: ServerData<MagentoShippingMethod[]>;
  orderDeliveryLimits: ServerData<IGetOrderDeliveryLimits>;
  orderAttributes: ServerData<OrderAttribute[]>;
  tradeInAttributes?: TradeInOrderAttributes | null;
  isAgeVerified: boolean | null;
  consentPurposes: string[];
  shippingSelectedAddressId?: string;
  accountContact?: Contact & { dob: DateOfBirth };
  isSelectShippingAddress: boolean;
  placingOrder: boolean;
  paymentToken: string;
  isPaymentMethodsListLoaded: boolean;
  pgsPaymentMethods: PgsPaymentMethod[];
  pgsClient: string;
  pgsAdapter: {
    client: string;
    paymentCode: string;
  };
  isPgsClientPending: boolean;
  isPaymentProcessing: boolean;
  loadedPgsClient: string;
  setShippingMethodsOnCartPending: boolean;
  updateAgeVerificationPending: boolean;
  isAgeVerificationSuccess: boolean;
  profileDataFetchStatus: ServerDataFetchStatus;
  selectedAddressForPayment?: Address;
  error: CheckoutError;
};
